exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-partials-timeslotscard-style__centered{text-align:center}.nil-sa-partials-timeslotscard-style__appointmentsContainer{min-height:183px}.nil-sa-partials-timeslotscard-style__morePromptSpacer{height:60px}.nil-sa-partials-timeslotscard-style__nextAvailable{cursor:pointer;text-align:center;padding:8px;margin:0 auto;margin-bottom:10px;background:#fff;border-radius:3px}.nil-sa-partials-timeslotscard-style__spinerOuter{min-height:183px;width:100%;text-align:center}.nil-sa-partials-timeslotscard-style__spinner{font-size:50px;margin-top:60px}.nil-sa-partials-timeslotscard-style__cardName{font-size:18px;padding-bottom:10px}", ""]);

// exports
exports.locals = {
	"centered": "nil-sa-partials-timeslotscard-style__centered",
	"appointmentsContainer": "nil-sa-partials-timeslotscard-style__appointmentsContainer",
	"morePromptSpacer": "nil-sa-partials-timeslotscard-style__morePromptSpacer",
	"nextAvailable": "nil-sa-partials-timeslotscard-style__nextAvailable",
	"spinerOuter": "nil-sa-partials-timeslotscard-style__spinerOuter",
	"spinner": "nil-sa-partials-timeslotscard-style__spinner",
	"cardName": "nil-sa-partials-timeslotscard-style__cardName"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/partials/TimeSlotsCard/style.less
// module id = 274
// module chunks = 0